import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import { connect } from 'react-redux';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import WorkspaceService from 'services/WorkspaceService';
import KnowledgeBuilder from 'builder/Knowledge/components/KnowledgeBuilder';
import getDocument from 'builder/Knowledge/queries/getDocument';
import { pushToast } from 'containers/ToastManager/actions';
import Spinner from 'components/FullScreenSpinner';
import { updateKnowledgeMapItemTitle } from 'Workspace/Knowledge/utils/uploadPrefix';
import simplifyDocumentQueryResult from '../../helpers/simplifyDocumentQueryResult';
import messages from './messages';
import gtmService from 'utils/gtm/gtmService';
import { pageName } from 'utils/gtm/constants';

// eslint-disable-next-line react/prefer-stateless-function
class KnowledgeBuilderContainer extends React.Component {

  componentDidMount() {
    gtmService.pushTelemetryPageActivityAndView({ pageName: pageName.KNOWLEDGE_BUILDER_PAGE });
  }
  render() {
    const { match, history, toast } = this.props;
    const workspaceId = WorkspaceService.getSelectedWorkspace().id;
    const documentId = match.params.documentId;

    return (
      <Query
        variables={{ workspaceId, documentId }}
        query={getDocument}
      >
        {({ loading, data, error }) => {
          if (loading) {
            // FIXME: replace with proper placeholders within the knowledge builder
            return <Spinner />;
          }

          if (error) {
            toast({
              type: 'simple',
              message: intl.formatMessage(messages.failedKnowledgeMapFetch),
            });
            history.push('/knowledge');
            // eslint-disable-next-line no-console
            console.error(error);
            return null;
          }

          const knowledgeMap = simplifyDocumentQueryResult(data);
          const updatedKnowledgeMap = updateKnowledgeMapItemTitle(knowledgeMap);
          if (!updatedKnowledgeMap) {
            return null;
          }

          return (
            <KnowledgeBuilder
              match={match}
              knowledgeMap={updatedKnowledgeMap}
              key={match.url}
            />
          );
        }}
      </Query>
    );
  }
}

KnowledgeBuilderContainer.propTypes = {
  history: PropTypes.object,
  match: PropTypes.shape({
    params: PropTypes.object,
    path: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  toast: PropTypes.func,
};

export default connect(
  undefined,
  (dispatch) => ({
    toast: (...args) => dispatch(pushToast(...args)),
  })
)(KnowledgeBuilderContainer);
